<template>
  <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  <div class="full-height pt-1 font colored_bk">
  <div  class="container">

      <div class="d-flex justify-content-between align-items-center mt-1">
        <div class="topTitle">账号管理</div>
        <router-link :to="`/index/user/usernotes`">笔记管理</router-link>
      </div>
      
     
      <div class="row d-flex justify-content-between" v-if="accounts!=undefined" >
        <div class="m-1" v-if="accounts.length==0">暂无账号，请点击左侧“添加账号”进行添加</div>
        <div class="col m-1" v-for="(account,index) in accounts" :key="index">
        
           <div class="card">
            <div class="d-flex justify-content p-1 align-items-center">
              <div v-if="account.user_info!=undefined&&account.user_info.imageb!=undefined">
                <img :src="account.user_info.imageb" class="account_icon">
              </div>
              <div v-else>
                <img src="../assets/tree.png" class="account_icon">
              </div>
              <div class="d-flex flex-column ml-1 justify-content-between">
                <div class="d-flex justify-content algin-items-center">
                    <div v-if="account.user_info==undefined" class="name">
                      新账号
                    </div>
                    <div v-else class="name">{{account.user_info.nickname}}</div>
                    
                </div>
                <div>
                      {{account.phone_no}}
                </div>
                
                <!-- <div v-if="account.fans!=undefined">
                  粉丝数：{{ account.fans }}
                </div> -->

               
                  <div v-if="account.title!=undefined">
                  {{ account.title.user_input }}
                </div>
           
                <div v-if="account.title!=undefined">
                  {{ account.title.day }}天{{ account.title.day_count }}篇
                </div>                
              </div>
          </div>
          <div  class="p-1 topBorder">
          <div v-if="role>0">
            有效期：永久
          </div>
           
            <div v-else>
              <div  v-if="account.auth!=undefined">
                <span class="right-gap" v-if="account.auth!=undefined">{{ account.auth.product_name }}：</span>
            <span :class="account.auth.expired?'expired':''">{{ formatDate(account.auth.start_date) }}至{{ formatDate(account.auth.end_date) }}</span>
              </div>
            
          </div>
           </div>
          <div class="row d-flex justify-content-between align-items-center p-1 topBorder">
           <div class="col invalidText">
              <span v-if="account.valid==false">无效用户</span>
              <div v-else>
                <span v-if="account.auth==undefined || account.auth.expired">会员过期</span>
                <div v-else>
                  <div v-if="account.cookies==undefined || account.cookies.cookie==undefined">
                    <span>需要授权</span>
                  </div>
                  <div v-else>
                    <span v-if="account.cookies.need_login || account.cookies.status==0">授权过期</span>
                  </div>
                 
                </div>
              </div>              
           </div>
           
            <!-- <router-link :to="`/index/user/product/${account.objectId}`" class="col">
              <div class="btn normalBtn vip">开通VIP</div></router-link> -->
          </div>

         <div class="topBorder"></div>
          <div class="row d-flex justify-content-between p-1 ">
            <div class='col-auto'>
              <router-link :to="`/qr/${account.objectId}`">
                <div class="d-flex justify-content-center flex-column align-items-center">
                <div >
                  <img class="operationIcon" src="../assets/icon-login.svg" alt="授权" title="授权">
                </div> 
                <div class="iconOp">授权</div>
              </div>
              </router-link>
            </div>
             <div class="col-auto" v-if="account.cookies!=undefined && account.cookies.cookie!=undefined">
              <router-link :to="`/index/user/newAccount/${account.objectId}`">
                <div class="d-flex justify-content-center flex-column align-items-center">
                <div >
                <img class="operationIcon" src="../assets/icon-setting.svg" alt="账号编辑" title="账号编辑">
                </div>
                <div class="iconOp">账号编辑</div>
              </div>
              </router-link>
             </div>
             <div class="col-auto" v-if="account.cookies!=undefined && account.cookies.cookie!=undefined">
              <router-link :to="`/index/user/note/${account.objectId}`">
                <div class="d-flex justify-content-center flex-column align-items-center">
                <div >
                <img class="operationIcon" src="../assets/icon-file.svg" alt="笔记管理" title="笔记管理">
                </div>
                <div class="iconOp">
                笔记管理
              </div>
            </div>
              </router-link>
             </div>
            </div>

          </div>

        
        </div>

      </div>
     


  </div> 

       
    </div>


</template>

<script>

import GridLoader from 'vue-spinner/src/GridLoader.vue'
import axios from 'axios';

// import AccountAuth from '@/components/AccountAuth.vue'
// import PhoneLogin from '@/components/PhoneLogin.vue';
import moment from 'moment';

export default {
  data(){
    
    return {
      accounts:[],
      isLoading:false,
      ifAdd:false,
      code_sent:false,
      count:180,
      timer:null,
      showPopup: false,
      selectedAccount:null,
      showContentPop:false,
      isValid: true,
      spinnerColor:"#262626",
      errors:'',
      qr_interval:null,
      logined:false,
      ifAddDetail:false,
      empty_back:false,
 

      
    }
    
  },
  computed: {
 
    countDown() {
      return `${this.count}秒`
    },
    formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }
  },

  components: {
    GridLoader,
   
    // AccountAuth
  },
   setup(){
    
     var token=localStorage.getItem('sessionToken')
     axios.defaults.headers.common['X-Parse-Session-Token'] = token

  },

  beforeUnmount(){

      if(this.qr_interval!=null)
      {
        clearInterval(this.qr_interval)
      }
  },

  mounted(){
    var token=localStorage.getItem('sessionToken');
    this.role=localStorage.getItem('role');

     if(token==undefined || token==null ||token=='')
     {
        this.$router.push('index')
        return
     }
     var empty=this.$route.query.empty_back
     if(empty==undefined)
     {
      this.empty_back=false
     }
     else
     {
      this.empty_back=true
     }

    this.getAccounts();
  },
  methods:{
     async getAccounts(){
      try{
        this.isLoading=true

        const response = await axios.get(this.domain+'xhs/get_accounts');

        var data=response.data
        if(data.status=='Suc')
        {
            var results=data.accounts
            this.accounts=results;
            console.log(data)
            if(this.accounts.length==0)
            {
              if(!this.empty_back)
              {
                this.$router.push('/index/user/newAccount?empty=true')
              }
              
              return
            }
        }
        else
        {
            console.error(data)
            
        }
      }
      catch(error)
      {
          console.error(data)
      }
      finally
      {
        this.isLoading=false
      }
     
     
    },



    

    async createAccounts(results){    

            this.accounts.push(results);
            this.selectedAccount=results
             
              this.ifAdd=false;
              this.showPopup=true;
 
    },

    async sendCode(account_id, status){
      try{
          // this.isLoading=false;
         
          const response = await axios.post(this.domain+'ai_code_send',{'account_id':account_id,'status':status});
        
          var data=response.data
          if(data.status=='Suc')
          {
              // this.isLoading=true;
              this.code_sent=true;
              this.countTimer()
            
          }
          else
          {
              console.error(data)
              
          }
        }
        catch(error)
        {
            console.error(data)
        }

    },

    beforeDestroy() {

    if (this.timer) {
      clearInterval(this.timer); // 在组件销毁前，清除定时器
    }
  
    if (this.qr_interval) {
      clearInterval(this.qr_interval); // 在组件销毁前，清除定时器
    }
  }
  }
   
  
};
</script>
<style scoped>
.card{
  height:max-content;
  min-width: 3rem;
  max-width:6rem;
}

.normlFont{
  color:#7D879A
}
.name{
  font-size:0.25rem;
  font-weight: 700;
}
.expired{
  color:#ec2151;
}
.account_icon{
height: 1rem;
border-radius:0.35rem;
}
.vip{
  color:white;

  padding:0.1rem;
}

.operationIcon{
  width:0.5rem;
  height:0.5rem;
  cursor:pointer
}


.iconOp{
  color:#434343;
}

.textbox_label{
  align-self: stretch;
 color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 400;
 line-height: normal;
}
.textBox{
  width:3.75rem;
}

.dropdown{
  width: 1.625rem;
}

.submitBtn{

 width: 3.75rem;
}

.error-message{
  color:red
}
</style>


